{
  "yourChoice": "Uw keuze",
  "yourCurrentSubscription": "Uw huidige abonnement",
  "checkoutForm": {
    "title": "Vul uw gegevens in"
  },
  "components": {
    "basePromotionCode": {
      "promotionCode": "Vul uw actiecode in",
      "apply": "Haal uw aanbod op"
    },
    "baseUspModalContent": {
      "cta": "Kies uw abonnement"
    }
  },
  "error": {
    "checkout": {
      "fallback": "Het plaatsen van uw bestelling is mislukt. Probeer het later opnieuw of neem contact op met de klantenservice.",
      "subscriber_exists": "Er bestaat al een {0}-abonnement met deze gegevens. Log in op Mijn Omgeving om uw huidige abonnement te beheren."
    }
  },
  "durationSelector": {
    "title": "Kies uw {0}",
    "titleWithoutDiscounts": "Kies uw looptijd",
    "tempDurationTitle": "Uw kortingsperiode",
    "singleDurationTitle": "Uw kortingsperiode",
    "duration": {
      "footerText": "{0} korting",
      "footerTextVariation": "{0} korting, u bespaart {1} per jaar",
      "temporaryPromoBadge": "Tijdelijke actie"
    },
    "disclaimer": {
      "variation": "De korting is geldig voor {0} maanden, ook tijdens deze periode kunt u maandelijks opzeggen.",
      "default": "Na deze periode kunt u maandelijks opzeggen.",
      "afterDuration": "Na {0} {1} kunt u maandelijks opzeggen.",
      "cancel": "U kunt uw bestelling binnen 14 dagen annuleren.",
      "trialSubscription": "Na deze periode stopt uw proefabonnement vanzelf.",
      "freeSubscription": "Na {0} {1} stopt uw gratis abonnement vanzelf.",
      "fluisterFreeMonth": "U ontvangt in de eerste twee maanden één maand gratis. Daarom krijgt u in deze periode {0}% korting op uw factuur (u leest dan voor €{1} per week). Na de tweede maand leest u voor €{2} per week en kunt u maandelijks opzeggen."
    }
  },
  "orderNote": "U ontvangt binnen 24 uur een bevestigingsmail.<br/>U kunt uw bestelling binnen 14 dagen annuleren.",
  "orderNoteCsr": "U ontvangt binnen 24 uur een bevestigingsmail.",
  "basePvExplanation": {
    "title": "Hoelang krijg ik korting?",
    "description": "Uitleg over de kortingsperiode",
    "intro": "U krijgt in totaal maar liefst {duration} korting op het reguliere tarief:",
    "firstPeriod": "Bij deze actie geldt de eerste {period} een kennismakingstarief van {price}",
    "middlePeriod": "Vervolgens geldt {period} een kortingstarief van {price}",
    "lastPeriod": "Daarna geldt {period} een kortingstarief van {price}.",
    "regularRate": "Na {duration} gaat het reguliere tarief in.",
    "cancellation": "Het abonnement is {info} opzegbaar"
  },
  "productOverview": {
    "title": "Kies uw nieuwe tijdschrift",
    "filterCategory": "Filter op categorie",
    "filterType": "Filter op type",
    "noResults": "Sorry! We kunnen niet vinden wat u zoekt.",
    "results": "We waren op zoek naar",
    "search": "Zoeken",
    "clear": "Reset"
  },
  "links": {
    "productCardCta": "Bekijk aanbod",
    "discoverAll": "Ontdek alles"
  },
  "endlessFaq": {
    "label": "Stel uw eigen vraag",
    "placeholder": "Stel uw eigen vraag",
    "submit": "Vraag stellen",
    "loading": "Even kijken...",
    "error": "Er is iets misgegaan. Probeer het opnieuw.",
    "rateLimited": "U heeft veel vragen gesteld. Probeer het over een minuut opnieuw.",
    "disclaimer": "Antwoorden worden gegenereerd door AI en kunnen fouten bevatten. Neem bij twijfel contact op met onze {customerService}.",
    "customerService": "klantenservice"
  }
}
